import { FC } from "react";

import { MediaQueryDynamicImport } from "@ctra/components";

export const Onboarding: FC = () => {
  return (
    <MediaQueryDynamicImport mobile={() => import("./Mobile")} desktop={() => import("./Desktop")}>
      {(Component) => <Component />}
    </MediaQueryDynamicImport>
  );
};
